import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsappColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#bw-whatsapp-clip)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0544 4.90641C17.1825 3.03328 14.6935 2.00114 12.0417 2C6.57714 2 2.1301 6.44562 2.12791 11.9099C2.12727 13.6566 2.58366 15.3616 3.45112 16.8646L2.04468 22L7.30009 20.622C8.74805 21.4116 10.3784 21.8277 12.0374 21.8284H12.0416H12.0417C17.5054 21.8284 21.9531 17.382 21.9554 11.918C21.9563 9.2697 20.926 6.77968 19.0544 4.90641ZM12.0417 20.1546H12.0385C10.5597 20.1538 9.1095 19.7568 7.8446 19.0062L7.54358 18.8278L4.42491 19.6454L5.25755 16.6059L5.06142 16.2942C4.23653 14.9827 3.80106 13.4669 3.80168 11.9106C3.8035 7.36881 7.49971 3.67389 12.0448 3.67389C14.2458 3.6748 16.3145 4.53272 17.8703 6.08961C19.426 7.64649 20.2821 9.71614 20.2815 11.9173C20.2795 16.4592 16.5832 20.1546 12.0417 20.1546Z",
				fill: "#E0E0E0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.49976 21.4302L3.84196 16.5294C3.0139 15.0951 2.57845 13.4678 2.57897 11.8013C2.58114 6.58666 6.82509 2.34424 12.0396 2.34424C14.5704 2.34538 16.9458 3.33032 18.7317 5.11793C20.518 6.90553 21.5012 9.28165 21.5001 11.8087C21.498 17.0234 17.2538 21.2662 12.0399 21.2662C12.0396 21.2662 12.0402 21.2662 12.0399 21.2662H12.0357C10.4525 21.2657 8.89673 20.8682 7.515 20.1152L2.49976 21.4302Z",
				fill: "url(#bw-whatsapp-gradient)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.59184 7.70276C9.40843 7.29497 9.21532 7.28681 9.04083 7.27968C8.8981 7.27355 8.73471 7.27393 8.57158 7.27393C8.40831 7.27393 8.14301 7.33528 7.91866 7.58031C7.69417 7.82534 7.06152 8.41767 7.06152 9.62237C7.06152 10.8272 7.93906 11.9914 8.06138 12.1549C8.18383 12.3181 9.75537 14.8694 12.2442 15.8509C14.3127 16.6665 14.7336 16.5043 15.1826 16.4635C15.6316 16.4227 16.6313 15.8713 16.8354 15.2995C17.0395 14.7278 17.0395 14.2377 16.9782 14.1353C16.917 14.0333 16.7537 13.972 16.5088 13.8496C16.264 13.7272 15.0601 13.1347 14.8357 13.0531C14.6112 12.9714 14.4479 12.9306 14.2846 13.1758C14.1214 13.4207 13.6524 13.972 13.5095 14.1353C13.3667 14.2989 13.2238 14.3194 12.9789 14.1969C12.734 14.0741 11.9454 13.8158 11.0098 12.9816C10.2819 12.3326 9.79043 11.5311 9.64758 11.286C9.50472 11.0411 9.63227 10.9084 9.7551 10.7864C9.86505 10.6767 10 10.5005 10.1224 10.3575C10.2446 10.2145 10.2854 10.1125 10.3671 9.94924C10.4487 9.78572 10.4079 9.64275 10.3467 9.5203C10.2854 9.39785 9.80957 8.18693 9.59184 7.70276Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.9734 4.87501C17.123 3.02338 14.6626 2.00311 12.0412 2.00195C6.63937 2.00195 2.24338 6.39654 2.2412 11.7981C2.24057 13.5248 2.69171 15.2102 3.54922 16.6959L2.15894 21.7724L7.35402 20.4101C8.78538 21.1907 10.397 21.6021 12.037 21.6027H12.0412H12.0412C17.4421 21.6027 21.8388 17.2074 21.8411 11.806C21.842 9.18821 20.8235 6.72677 18.9734 4.87501ZM12.0412 19.9482H12.038C10.5762 19.9474 9.14265 19.5549 7.89228 18.813L7.5947 18.6366L4.51184 19.4448L5.33491 16.4402L5.14104 16.1321C4.32562 14.8356 3.89514 13.3373 3.89578 11.7988C3.89756 7.30917 7.55134 3.65666 12.0443 3.65666C14.22 3.65756 16.2649 4.50563 17.8029 6.04464C19.3407 7.58366 20.187 9.62954 20.1864 11.8054C20.1845 16.2951 16.5306 19.9482 12.0412 19.9482Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "bw-whatsapp-gradient",
		x1: 12,
		y1: 21.4302,
		x2: 12,
		y2: 2.34427,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#20B038" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#60D66A"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "bw-whatsapp-clip",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(2 2)"
		})
	})] })]
});
export default SvgWhatsappColor;
